import { Component, inject, OnInit } from '@angular/core';
import { MessageService } from '../message.service';
import { Message } from '../message';
import { take, tap } from 'rxjs/operators';
import { ErrorDialogComponent } from '../../shared/dialogs/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { MatCard, MatCardContent } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lfw-message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.css'],
  imports: [MatToolbar, MatButton, MatIcon, MatCard, MatCardContent, TranslatePipe]
})
export class MessageViewComponent implements OnInit {
  public messages: Message[] = [];
  private dialog = inject(MatDialog);
  private messageService = inject(MessageService);

  ngOnInit(): void {
    this.loadMessages();
  }

  loadMessages() {
    this.messageService
      .getMessages()
      .pipe(
        tap((res) => (this.messages = res)),
        take(1)
      )
      .subscribe();
  }

  deleteMessage(msg: Message): void {
    if (msg == null) {
      return;
    }

    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'MESSAGES.DLG_DELETE_TITLE',
        message: 'MESSAGES.DLG_DELETE_TEXT',
        okIsDefault: 'true'
      }
    });

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === true) {
        this.messageService.deleteMessage(msg.id).subscribe((success) => {
          this.refreshUI(success);
        });
      }
    });
  }

  deleteAllMessages(): void {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'MESSAGES.DLG_DELETEALL_TITLE',
        message: 'MESSAGES.DLG_DELETEALL_TEXT',
        okIsDefault: 'true'
      }
    });

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === true) {
        this.messageService.deleteAllMessages().subscribe((success) => {
          this.refreshUI(success);
        });
      }
    });
  }

  refreshUI(success: boolean): void {
    console.log(success);
    if (success) {
      this.loadMessages();
      return;
    } else {
      const dlg = this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'ERROR.DLG_ERROR_TITLE',
          message: 'MESSAGES.DLG_DELETE_FAILED'
        }
      });
      dlg.afterClosed().subscribe(() => {
        this.loadMessages();
      });
    }
  }
}
